export const summary =
    "Hey, my name is Alex and I am a Software Engineer. I have experience as a Full Stack Web App Developer and I enjoy working with all layers of the stack.";
